(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jp-autumn-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jp-autumn-product-offer')) {
    customElements.define('jp-autumn-product-offer',class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        document.addEventListener('variant:change',event => {
          if (String(event.detail.product?.id) !== this.dataset.productId) return;
          const variant = event.detail.variant;
          this.querySelectorAll('[data-coupon-variant]').forEach(coupon => {
            coupon.hidden = !variant || coupon.dataset.couponVariantId !== String(variant.id);
          });
        },{signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
